import React from 'react';

const Rank = ()=>{
    return(
        <div className>
            <div className="white f3 center">
                {/*'Hrishi, your current Rank is ...'*/}
            </div>
            <div className="white f1 center">
                {/*'#5'*/}
            </div>
        </div>
    );
}
export default Rank;